<template>
  <div class="survey-top-bottom-summary-360">
    <div
      class="p-3 py-5 items-center w-full justify-between flex-row"
      :class="{ 'bg-gray-200': index % 2 }"
    >
      <div class="w-3/5"></div>
      <div
        class="flex flex-wrap items-baseline flex-row w-full justify-between w-full"
      >
        <div class="w-full md:w-1/2 pr-1">
          <div class="w-full flex justify-center mb-2 text-sm">
            {{ $t("default.survey.strongest") }}
          </div>
          <div
            class="question mb-2 flex flex-row w-full justify-between items-center print-no-break"
            v-for="(question, i) in topQuestions"
            :key="`cq-${i}`"
          >
            <label>
              {{ translator(clang, question) }}
            </label>
            <div class="roles">
              <div class="chart">
                <BarChart
                  :value="question['corrAverage'] * 100"
                  :percentage-value="question['corrAverage']"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="w-full md:w-1/2 pl-1">
          <div class="w-full flex justify-center mt-6 md:mt-0 mb-2 text-sm">
            {{ $t("default.survey.weakest") }}
          </div>
          <div
            class="question mb-2 flex md:flex-row-reverse w-full justify-between items-center print-no-break"
            v-for="(question, i) in bottomQuestions"
            :key="`cq-${i}`"
          >
            <label>
              {{ translator(clang, question) }}
            </label>
            <div class="roles">
              <div class="chart">
                <BarChart
                  :value="question['corrAverage'] * 100"
                  :percentage-value="question['corrAverage']"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from "@/components/BarChart";
import translator from "../mixins/translator";

export default {
  props: {
    index: {
      required: true,
    },
    display_summary: {
      required: true,
    },
    questions: {
      default: [],
    },
    userResult: {
      default: false,
    },
    clang: {
      default: "fi",
    },
  },
  mixins: [translator],
  components: {
    BarChart,
  },
  computed: {
    sortedQuestions() {
      let q = this.questions;
      console.log("questions", q);
      const sorted = q
        .filter((q) => q.normalized_average !== undefined)
        .map((q) => {
          let corrAverage = q["normalized_average"]["all"];
          const ownAnswer = q.normalized_average["itse"];
          if (ownAnswer !== undefined) {
            // Remove own answer from average
            const numAnswers = q.answers.length;
            console.log("num answers", numAnswers, "average", corrAverage);
            if (numAnswers <= 1) {
              corrAverage = NaN;
            } else {
              corrAverage =
                (corrAverage * numAnswers - ownAnswer) / (numAnswers - 1);
            }
            console.log("new average: ", corrAverage);
          }
          return { corrAverage, ...q };
        })
        .filter((q) => !isNaN(q.corrAverage))
        .sort((a, b) => (a.corrAverage <= b.corrAverage ? 1 : -1));
      console.log("sorted", sorted);
      return sorted;
    },
    displaySummary() {
      // hardcoding 360 display summary here
      let s = 5;
      //let s = this.display_summary
      if (this.sortedQuestions.length / 2 < s)
        s = Math.ceil(this.sortedQuestions.length / 2);
      return s;
    },
    topQuestions() {
      return this.sortedQuestions.slice(0, this.displaySummary);
    },
    bottomQuestions() {
      console.log(
        "Number of bottom Questions: ",
        this.sortedQuestions
          .slice(
            this.sortedQuestions.length - this.displaySummary,
            this.sortedQuestions.length
          )
          .reverse().length
      );
      return this.sortedQuestions
        .slice(
          this.sortedQuestions.length - this.displaySummary,
          this.sortedQuestions.length
        )
        .reverse();
    },
    wideWidth() {
      const avg = this.topQuestions.map((ele) => ele["average"]);
      for (let ele of avg) {
        if (ele % 1 === 0) {
          return "w-20";
        }
      }
      return "w-24";
    },
  },
  methods: {
    ifDecimal(number) {
      if (typeof number != "number") {
        return "-";
      }
      if (number % 1 === 0) {
        return number.toFixed(0);
      }
      return number.toFixed(2);
    },
    sumAverages(question) {
      return Object.values(question["average"]).reduce(
        (col, { normalized_average }) => col + normalized_average,
        0
      );
    },
  },
};
</script>

<style>
.survey-top-bottom-summary-360 {
  .question {
    > label {
      flex: 1;
    }

    > div {
      flex: 2;
    }
  }

  .role-container {
    display: flex;
    flex-direction: row;
    margin: 0;

    label {
      font-size: 14px;
      flex-basis: 60px;
      overflow: hidden;
      margin: 0 5px;

      @media print {
        overflow: visible;
      }
    }

    .chart {
      flex: 1;
    }

    &:nth-child(2) {
      .chart {
        .background {
          .bar {
            background: var(--halsa-blue);
          }
        }
      }
    }
  }
}
</style>
